import { Box } from '@hivebrite/design-system/Box';
import { Skeleton } from '@hivebrite/design-system/Skeleton';

import { Col, Row } from 'hb-react/shared/components/DesignSystem/Grid';

const ListEventLoader = () => (
  <>
    <Row width="100%" height="auto">
      <Col>
        <Box p={6}>
          <Box flexDirection="column" mr={12}>
            <Skeleton height={19} mb={3} width={42} />
            <Skeleton height={42} width={42} />
          </Box>
          <Skeleton
            height={{ _: '151px', m: '122px', l: '163px', xl: '175px' }}
            width={{
              _: '283px',
              m: '227px',
              l: '304px',
              xl: '326px',
            }}
          />
          <Box flex={1} flexDirection="column" ml={6}>
            <Skeleton height={22} isLarge mb={4} width="100%" />
            <Skeleton height={16} isLarge mb={2} width="50%" />
            <Skeleton height={16} isLarge mb={2} width="50%" />
            <Skeleton height={16} isLarge width="40%" />
          </Box>
        </Box>
      </Col>
    </Row>
    <Row width="100%" height="auto">
      <Col>
        <Box p={6}>
          <Box flexDirection="column" mr={12}>
            <Skeleton height={19} mb={3} width={42} />
            <Skeleton height={42} width={42} />
          </Box>
          <Skeleton
            height={{ _: '151px', m: '122px', l: '163px', xl: '175px' }}
            width={{
              _: '283px',
              m: '227px',
              l: '304px',
              xl: '326px',
            }}
          />
          <Box flex={1} flexDirection="column" ml={6}>
            <Skeleton height={22} isLarge mb={4} width="100%" />
            <Skeleton height={16} isLarge mb={2} width="50%" />
            <Skeleton height={16} isLarge mb={2} width="50%" />
            <Skeleton height={16} isLarge width="40%" />
          </Box>
        </Box>
      </Col>
    </Row>
    <Row width="100%" height="auto">
      <Col>
        <Box p={6}>
          <Box flexDirection="column" mr={12}>
            <Skeleton height={19} mb={3} width={42} />
            <Skeleton height={42} width={42} />
          </Box>
          <Skeleton
            height={{ _: '151px', m: '122px', l: '163px', xl: '175px' }}
            width={{
              _: '283px',
              m: '227px',
              l: '304px',
              xl: '326px',
            }}
          />
          <Box flex={1} flexDirection="column" ml={6}>
            <Skeleton height={22} isLarge mb={4} width="100%" />
            <Skeleton height={16} isLarge mb={2} width="50%" />
            <Skeleton height={16} isLarge mb={2} width="50%" />
            <Skeleton height={16} isLarge width="40%" />
          </Box>
        </Box>
      </Col>
    </Row>
  </>
);

export default ListEventLoader;
